import type { CertGenParams } from '@yandex-int/k-common';

import { formatCityDate } from 'utils/date/format-city-date';
import { intoHtml } from 'utils/html';

interface Props extends CertGenParams {
    issue_date?: string;
}

export const TeacherReserveProforientation = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
    issue_date: issueDate,
}: Props) => {
    const formattedDate = issueDate ? formatCityDate('Москва', issueDate) : 'Москва, 2024';

    return intoHtml`<!DOCTYPE html>
<html lang="ru" xmlns="http://www.w3.org/1999/html">
  <head>
    <meta charset="utf-8" />
    <meta name="description" content="" />
    <meta name="keywords" content="" />
    <meta
      name="viewport"
      content="width=device-width, maximum-scale=1.0, initial-scale=1.0"
    />
    <style type="text/css">
      /*
            //-----------------------------------------
            // Fonts
            //-----------------------------------------
            */

      @font-face {
        font-family: "YS Text";
        src: url("https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2")
            format("woff2"),
          url("https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff")
            format("woff");
        font-weight: 400;
        font-style: normal;
      }

      @font-face {
        font-family: "YS Text";
        src: url("https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2")
            format("woff2"),
          url("https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff")
            format("woff");
        font-weight: 500;
        font-style: normal;
      }

      /*
            //-----------------------------------------
            // Print specifics
            // Игнорирует отключение фона при печати
            //-----------------------------------------
            */

      @page {
        size: 210mm 297mm;
        margin: 0;
      }

      @media print {
        html,
        body {
          color-adjust: exact;
          print-color-adjust: exact;
          -webkit-print-color-adjust: exact;
        }
      }

      /*
            //-----------------------------------------
            // Scaffolding
            //-----------------------------------------
            */

      html,
      body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
      }

      body {
        font-size: calc(14 * 297mm / 842);
        font-weight: 400;
        font-family: "YS Text";
        line-height: calc(16 * 297mm / 842);
        color: #000;
        min-height: 100%;
        height: 100%;
        background: #ffffff;
        -webkit-text-size-adjust: 100%;
      }

      * {
        box-sizing: border-box;
      }

      /*
            //-----------------------------------------
            // Certificate
            //-----------------------------------------
            */

      .page {
        position: relative;
        width: 210mm;
        height: 297mm;
        overflow: hidden;
        page-break-after: always;
        break-after: page;
        padding: calc(30 * 297mm / 842) calc(30 * 297mm / 842);

        background-image: url("https://avatars.mds.yandex.net/get-schoolbook-images/5406199/GfWoaj8EqnuTfyfl-QUCa/orig");
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
      }

      .logo {
        width: calc(197 * 297mm / 842);
        height: calc(24 * 297mm / 842);
      }

      .info {
        width: calc(325 * 297mm / 842);
        margin-top: calc(36 * 297mm / 842);
      }

      .info__title {
        font-size: calc(32 * 297mm / 842);
        font-weight: 500;
        line-height: calc(37.5 * 297mm / 842);
        margin-bottom: calc(8 * 297mm / 842);
      }

      .info__subtitle {
        margin-bottom: calc(28 * 297mm / 842);
      }

      .info__name {
        font-size: calc(28 * 297mm / 842);
        line-height: calc(31 * 297mm / 842);

        margin-bottom: calc(12 * 297mm / 842);
      }

      .info__teacher {
        margin-bottom: calc(12 * 297mm / 842);
      }

      .info__school {
        margin-bottom: calc(12 * 297mm / 842);
      }

      .info__description {
        font-weight: 500;
      }

      .signature {
        position: absolute;
        bottom: calc(36 * 297mm / 842);
        left: calc(48 * 297mm / 842);
      }

      .signature__img {
        width: calc(144 * 297mm / 842);
      }

      .signature__name {
        font-size: 13pt;
        font-weight: bold;
        line-height: 15pt;

        margin-top: calc(17 * 297mm / 842);
      }

      .signature__position {
        font-size: 12pt;
        line-height: 14pt;

        margin-top: calc(4 * 297mm / 842);
      }

      .signature__date {
        font-size: 10pt;
        margin-top: calc(24 * 297mm / 842);
      }
    </style>
  </head>

  <body>
    <div class="page">
      <img
        class="logo"
        src="https://e7n.s3.yandex.net/static/cert-inf-2022-spring-olymp/logo.svg"
        alt="Лого Яндекс"
      />
      <div class="info">
        <div class="info__title">
          Благодарственное<br />
          письмо
        </div>
        <div class="info__subtitle">награждается</div>

        <div class="info__name">
          ${firstName ? `${firstName}` : ''} ${middleName ? `${middleName}` : ''}<br />
          ${lastName ? `${lastName}` : ''}
        </div>

        <div class="info__teacher">учитель информатики</div>

        <div class="info__school">${schoolName ? `${schoolName}` : ''}</div>

        <div class="info__description">
          Команда Яндекс Учебника высоко <br />ценит вашу помощь и благодарит
          <br />за проведение урока профориентации
        </div>
      </div>

      <div class="signature">
        <img
          class="signature__img"
          src="https://avatars.mds.yandex.net/get-schoolbook-images/6887102/-BaucEy53CUy-_gUtf7xC/orig"
          alt="подпись Краевской"
        />
        <div class="signature__name">Е.Б. Краевская</div>
        <div class="signature__position">
          Руководитель сервиса<br />
          Яндекс Учебник
        </div>

        <div class="signature__date">${formattedDate}</div>
      </div>
    </div>
  </body>
</html>
`;
};
